"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.find.title': '切换网页搜索',
    'shortcuts.find.description': '启用或禁用网页搜索功能',
};
